import type { Form } from '../../../../common/types/form';
import type { FbMeasure } from '../../../../common/types/client';

const measureForm: Form<FbMeasure> = {
  key: 'measure',
  title: 'Maßnahmen',
  fields: [
    {
      key: 'date',
      label: 'Datum',
      fieldTypes: 'date',
    },
    {
      key: 'type',
      label: 'Art der Maßnahme',
      fieldTypes: 'select',
      options: [
        {
          value: 'consultationLocally',
          label: 'Beratung vor Ort',
        },
        {
          value: 'consultationLocallyWithChildcare',
          label: 'Beratung vor Ort mit Kinderbetreuung',
        },
        {
          value: 'outreachConsultation',
          label: 'Aufsuchende Beratung',
        },
        {
          value: 'groupParticipation',
          label: 'Gruppenteilnahme',
        },
        {
          value: 'byPhone',
          label: 'Telefonisch',
        },
        {
          value: 'sms',
          label: 'SMS',
        },
        {
          value: 'email',
          label: 'E-Mail',
        },
        {
          value: 'online',
          label: 'Online',
        },
        {
          value: 'support',
          label: 'Begleitung',
        },
        {
          value: 'statement',
          label: 'Stellungnahme',
        },
        {
          value: 'contactWithOtherProfessionals',
          label: 'Kontakt mit anderen Fachkräften',
        },
        {
          value: 'contactWithOtherServices',
          label: 'Kontakt mit anderen Diensten',
        },
        {
          value: 'sendingOfLists',
          label: 'Zusendung / Aushändigen von Listen (PT / RA / Kliniken)',
        },
        {
          value: 'sendingOfInfoMaterial',
          label: 'Zusendung von Infomaterial',
        },
      ],
    },
    {
      key: 'notShownUp',
      label: 'nicht aufgetaucht',
      fieldTypes: 'checkbox',
    },
    {
      key: 'notice',
      label: 'Gesprächsnotiz',
      fieldTypes: 'richTextArea',
      rows: 15,
    },
  ],
};

export default measureForm;
